<template>
  <div class="member">
    <div class="flex-box flex-v-c picker bb">
      <div class="flex1 flex-box flex-hv-c startTime" @click="openPick('startTime')">
        {{startValue}}
        <span v-show="!startValue">开始时间</span>
      </div>
      <div class="flex1 flex-box flex-hv-c endTime" @click="openPick('endTime')">
        {{endValue}}
        <span v-show="!endValue">结束时间</span>
      </div>
    </div>

    <div class="flex-box flex-v-c status">
      <div class="flex1 statusBtn" :class="{focusBtn:focusNum==0}" @click="changLeague(0)">全部</div>
      <div class="flex1 statusBtn" :class="{focusBtn:focusNum==1}" @click="changLeague(1)">已联盟代理</div>
      <div class="flex1 statusBtn" :class="{focusBtn:focusNum==2}" @click="changLeague(2)">未联盟代理</div>
      <div class="flex1 dirBtn flex-box flex-hv-c" @click="districtSwitch">
        <select id="sel" class="selectDistrict" @change="select" v-model="sendData.district">
          <option value selected>全部</option>
          <option
            :value="item.value"
            :key="item.value"
            v-for="(item,index) in districtList"
          >{{item.label}}</option>
        </select>
        <!-- <i class="iconfont" :class="{iconXiajiantou:!districtShow,iconShangjiantou:districtShow}"></i> -->
        <i class="iconfont iconXiajiantou"></i>
      </div>
    </div>
    <div class="flex-box flex-v-c br bb">
      <div class="flex1 flex-box flex-v-c">
        <input class="searchInput" type="number" v-model="sendData.param" placeholder="代理/游戏ID/昵称" />
        <div class="closeBtn" v-show="sendData.param" @click="clear"></div>
      </div>
      <div class="flex-box flex-v-c">
        <!-- 替换一个假按钮，一点2秒后变为真按钮 -->
        <!-- <div class="button searchBtn" v-show="!isRefresh" @click="refresh">
          重置
          <i class="iconfont icon-refresh"></i>
        </div>
        <div class="button searchBtn" v-show="isRefresh">
          重置
          <i class="iconfont icon-refresh"></i>
        </div>-->
        <div class="button searchBtn" @click="search">
          搜索
          <i class="iconfont icon-search"></i>
        </div>
      </div>
    </div>
    <div class="flex-box flex-h-c nav bb">
      <div
        class="flex1 flex-box flex-hv-c"
        :class="{focus:showClubType==0}"
        @click.stop="changClubType(0)"
      >元宝模式</div>
      <div
        class="flex1 flex-box flex-hv-c"
        :class="{focus:showClubType==1}"
        @click.stop="changClubType(1)"
      >钻石模式</div>
    </div>

    <div class="flex-box flex-h-c nav bb">
      <div class="flex1 flex-box flex-hv-c" :class="{focus:showType==1}" @click.stop="changType(1)">
        直接推荐
        <span>{{zhijieTotal}}</span>
      </div>
      <div class="flex1 flex-box flex-hv-c" :class="{focus:showType==2}" @click.stop="changType(2)">
        间接推荐
        <span>{{jianijieTotal}}</span>
      </div>
    </div>

    <div class="search flex-box flex-hv-c bb" @click="sortSwitch">
      综合
      <i class="iconfont" :class="{iconXiajiantou:!sortListShow,iconShangjiantou:sortListShow}"></i>
    </div>

    <!-- 上下拉 -->
    <Cloadmore @loadBottom="loadBottom" @loadTop="loadTop" ref="listTopic">
      <ul v-if="list.length>0" v-cloak>
        <li v-for="(item,index) in list" :key="item.id" class="bb" @click="details(item.id)">
          <div class="flex-box flex-v-c player">
            <!--<div class=""><img class="avatar" :src="item.avatar" alt=""></div>-->
            <div class="flex1">
              <div class="overEll">姓名：{{item.realname}}</div>
              <div class="overEll">昵称：{{item.nickname}}</div>
              <div>
                代理：
                <span class="tip">{{item.level | levelText}}-{{item.id}}</span>
                <span class="success" v-if="item.status==0">-(正常)</span>
                <span v-else class="tip">-(被封)</span>
              </div>
            </div>
            <div class="flex1" v-show="!isMoneyMode">
              欠钻石:
              <span class="tip">{{item.fangkaArrearage}} 个</span>
            </div>
          </div>
          <div class="flex-box flex-v-c">
            <div class="flex1" v-show="isMoneyMode">
              绑定玩家数：
              <span class="tip">{{item.bindCount}}</span>
            </div>
            <div class="flex1" v-show="!isMoneyMode">
              钻石亲友圈玩家数：
              <span class="tip">{{item.fangkaPlayerCount}}</span>
            </div>
            <div class="flex1">
              二级代理数：
              <span class="tip">{{item.twoMemberCount}}</span>
            </div>
          </div>
          <div class="flex-box flex-v-c">
            <div class="tip">开房——</div>
            <div class="flex1">
              日开房：
              <span class="tip">{{item.createRoomDay}}</span>
            </div>
            <div class="flex1">
              月开房：
              <span class="tip">{{item.createRoomMonth}}</span>
            </div>
          </div>
          <div v-show="isMoneyMode">
            <div class="flex-box flex-v-c">
              <div class="tip">充值——</div>
              <div class="flex1">
                月充值：
                <span class="tip">{{item.totalAmount}}</span>
              </div>
              <div class="flex1">
                <!-- 总充值：
                <span class="tip">{{item.directRecharge}}</span>-->
              </div>
            </div>
            <div class="flex-box flex-v-c">
              <div class="tip">宝箱——</div>
              <div class="flex1">
                月宝箱：
                <span class="tip">{{item.treasCountMonth}}</span>
              </div>
              <div class="flex1">
                <!-- 总宝箱：
                <span class="tip">{{item.treasCountTotal}}</span>-->
              </div>
            </div>
          </div>
          <!-- 钻石模式 -->
          <div v-show="!isMoneyMode">
            <!-- <div class="flex-box flex-v-c">
              <div class="tip">奖励——</div>
              <div class="flex1">
                日奖励：
                <span class="tip">{{item.fangkaTodayFanli}}</span>
              </div>
              <div class="flex1">
                月奖励：
                <span class="tip">{{item.fangkaMonthFanli}}</span>
              </div>
            </div>-->
            <div class="flex-box flex-v-c">
              <div class="tip">消耗——</div>
              <div class="flex1">
                日消耗：
                <span class="tip">{{item.fangkaTodayCost}} 个</span>
              </div>
              <div class="flex1">
                月消耗：
                <span class="tip">{{item.fangkaMonthCost}} 个</span>
              </div>
            </div>
            <div class="flex-box flex-v-c">
              <div class="tip">联盟场次——</div>
              <div class="flex1">
                日场次：
                <span class="tip">{{item.leagueGameDay}} 场</span>
              </div>
              <div class="flex1">
                月场次：
                <span class="tip">{{item.leagueGameMonth}} 场</span>
              </div>
            </div>
          </div>
          <div class="flex-box flex-h-e time">{{item.authTime | formatDate}}</div>
          <i class="iconfont icon-more more"></i>
        </li>
      </ul>
      <div v-else class="nullData">暂无数据~</div>
    </Cloadmore>
    <!--综合排序 -->
    <transition name="transUp">
      <div class="overView" v-show="sortListShow" @click="sortSwitch">
        <ul class="sortList flex-box">
          <li class="flex-box flex-v-c bb br" @click.stop="sort(1)">
            授权时间降序
            <i class="trueIcon" v-show="sendData.order==1"></i>
          </li>
          <li class="flex-box flex-v-c bb" @click.stop="sort(2)">
            授权时间升序
            <i class="trueIcon" v-show="sendData.order==2"></i>
          </li>
          <li class="flex-box flex-v-c bb br" @click.stop="sort(3)" v-show="isMoneyMode">
            绑定玩家数降序
            <i class="trueIcon" v-show="sendData.order==3"></i>
          </li>
          <li class="flex-box flex-v-c bb" @click.stop="sort(4)" v-show="isMoneyMode">
            绑定玩家数升序
            <i class="trueIcon" v-show="sendData.order==4"></i>
          </li>
          <li class="flex-box flex-v-c bb br" @click.stop="sort(19)" v-show="!isMoneyMode">
            亲友圈玩家数降序
            <i class="trueIcon" v-show="sendData.order==19"></i>
          </li>
          <li class="flex-box flex-v-c bb" @click.stop="sort(20)" v-show="!isMoneyMode">
            亲友圈玩家数升序
            <i class="trueIcon" v-show="sendData.order==20"></i>
          </li>

          <li class="flex-box flex-v-c bb br" @click.stop="sort(5)">
            二级代理数降序
            <i class="trueIcon" v-show="sendData.order==5"></i>
          </li>
          <li class="flex-box flex-v-c bb" @click.stop="sort(6)">
            二级代理数升序
            <i class="trueIcon" v-show="sendData.order==6"></i>
          </li>
          <li class="flex-box flex-v-c bb br" @click.stop="sort(7)">
            日开房降序
            <i class="trueIcon" v-show="sendData.order==7"></i>
          </li>
          <li class="flex-box flex-v-c bb" @click.stop="sort(8)">
            日开房升序
            <i class="trueIcon" v-show="sendData.order==8"></i>
          </li>
          <li class="flex-box flex-v-c bb br" @click.stop="sort(9)">
            月开房降序
            <i class="trueIcon" v-show="sendData.order==9"></i>
          </li>
          <li class="flex-box flex-v-c bb" @click.stop="sort(10)">
            月开房升序
            <i class="trueIcon" v-show="sendData.order==10"></i>
          </li>
          <!-- 元宝模式 -->

          <ul v-show="isMoneyMode" class="part flex-box">
            <li class="flex-box flex-v-c bb br" @click.stop="sort(11)">
              月充值降序
              <i class="trueIcon" v-show="sendData.order==11"></i>
            </li>
            <li class="flex-box flex-v-c bb" @click.stop="sort(12)">
              月充值升序
              <i class="trueIcon" v-show="sendData.order==12"></i>
            </li>
            <!-- <li class="flex-box flex-v-c bb br" @click.stop="sort(13)">
              总充值降序
              <i class="trueIcon" v-show="sendData.order==13"></i>
            </li>
            <li class="flex-box flex-v-c bb" @click.stop="sort(14)">
              总充值升序
              <i class="trueIcon" v-show="sendData.order==14"></i>
            </li>-->
            <li class="flex-box flex-v-c bb br" @click.stop="sort(15)">
              月宝箱降序
              <i class="trueIcon" v-show="sendData.order==15"></i>
            </li>
            <li class="flex-box flex-v-c bb" @click.stop="sort(16)">
              月宝箱升序
              <i class="trueIcon" v-show="sendData.order==16"></i>
            </li>
            <!-- <li class="flex-box flex-v-c bb br" @click.stop="sort(17)">
              总宝箱降序
              <i class="trueIcon" v-show="sendData.order==17"></i>
            </li>
            <li class="flex-box flex-v-c bb" @click.stop="sort(18)">
              总宝箱升序
              <i class="trueIcon" v-show="sendData.order==18"></i>
            </li>-->
          </ul>

          <!-- 钻石模式 -->
          <ul v-show="!isMoneyMode" class="part flex-box">
            <!-- <li class="flex-box flex-v-c bb br" @click.stop="sort(21)">
              日奖励降序
              <i class="trueIcon" v-show="sendData.order==21"></i>
            </li>
            <li class="flex-box flex-v-c bb" @click.stop="sort(22)">
              日奖励升序
              <i class="trueIcon" v-show="sendData.order==22"></i>
            </li>-->
            <!-- <li class="flex-box flex-v-c bb br" @click.stop="sort(23)">
              月奖励降序
              <i class="trueIcon" v-show="sendData.order==23"></i>
            </li>
            <li class="flex-box flex-v-c bb" @click.stop="sort(24)">
              月奖励升序
              <i class="trueIcon" v-show="sendData.order==24"></i>
            </li>-->
            <li class="flex-box flex-v-c bb br" @click.stop="sort(25)">
              日消耗钻石降序
              <i class="trueIcon" v-show="sendData.order==25"></i>
            </li>
            <li class="flex-box flex-v-c bb" @click.stop="sort(26)">
              日消耗钻石升序
              <i class="trueIcon" v-show="sendData.order==26"></i>
            </li>
            <li class="flex-box flex-v-c bb br" @click.stop="sort(27)">
              月消耗钻石降序
              <i class="trueIcon" v-show="sendData.order==27"></i>
            </li>
            <li class="flex-box flex-v-c bb" @click.stop="sort(28)">
              月消耗钻石升序
              <i class="trueIcon" v-show="sendData.order==28"></i>
            </li>
            <li class="flex-box flex-v-c bb br" @click.stop="sort(29)">
              联盟日场次降序
              <i class="trueIcon" v-show="sendData.order==29"></i>
            </li>
            <li class="flex-box flex-v-c bb" @click.stop="sort(30)">
              联盟日场次升序
              <i class="trueIcon" v-show="sendData.order==30"></i>
            </li>
            <li class="flex-box flex-v-c bb br" @click.stop="sort(31)">
              联盟月场次降序
              <i class="trueIcon" v-show="sendData.order==31"></i>
            </li>
            <li class="flex-box flex-v-c bb" @click.stop="sort(32)">
              联盟月场次升序
              <i class="trueIcon" v-show="sendData.order==32"></i>
            </li>
          </ul>
        </ul>
      </div>
    </transition>
    <!-- 时间选择 -->
    <mt-datetime-picker
      ref="startTime"
      v-model="pickerValue"
      type="date"
      year-format="{value} 年"
      month-format="{value} 月"
      date-format="{value} 日"
      :startDate="startDate"
      :endDate="endDate"
      @confirm="handleConfirm('start')"
    ></mt-datetime-picker>
    <mt-datetime-picker
      ref="endTime"
      v-model="pickerValue2"
      type="date"
      year-format="{value} 年"
      month-format="{value} 月"
      date-format="{value} 日"
      :startDate="startDate"
      :endDate="endDate"
      @confirm="handleConfirm('end')"
    ></mt-datetime-picker>

    <transition name="trans">
      <detail
        :memberId="memberId"
        :managerId="this.$route.query.managerId"
        class="detail"
        v-if="detailShow"
        @ctrDetails="ctrDetails"
      ></detail>
    </transition>
  </div>
</template>
<!--javascript-->
<script>
import Cloadmore from '../loadmore/loadmore.vue';
import detail from './detail.vue';
export default {
  components: { Cloadmore, detail },
  name: 'member',
  data: function () {
    return {
      startValue: '',
      endValue: '',
      pickerValue: '',
      pickerValue2: '',
      startDate: new Date('2016/01/1'),
      zhijieTotal: 0,
      jianijieTotal: 0,
      focusNum: 0,
      lastClickTime: new Date().getTime() - 1300,
      sortListShow: false,
      districtShow: false,
      detailShow: false,
      isRefresh: false,
      districtList: this.$store.state.envData[localStorage.env].district,
      ////
      memberId: '',
      loader: false,
      list: [],
      dataLength: '',
      replaceTitleShow: '',//其他商务下的代理 标题
      url: '/member/list',//我的代理列表  有manageId则是其他商务的代理subManager/memberInfo
      showType: 1,//默认直接接推荐
      showClubType: 0,//默认元宝模式
      sendData: {
        // managerId: '',//可查看其他商务的数据
        index: 1,
        type: 1,//默认直接接推荐
        clubType: 0,//默认元宝模式
        order: 1,
        level: '',
        param: '',
        district: '',
        begin: '',
        end: ''
      }
    }
  },
  watch: {
    // currentType(v, ov) {
    //   console.log(v + '---' + ov)
    //   console.log(this.showType)
    //   if (v != this.showType) {
    //     this.sendData.index = 1
    //     if (!this.isRefresh) {
    //       this.getData('getNewData', (type, clubType, erro) => {
    //         this.showType = type
    //       })
    //     }
    //     this.$refs.listTopic.setAllLoaded(false) //开启上拉加载
    //   }
    // },
    // currentClubType(v, ov) {
    //   console.log(v + '---' + ov)
    //   console.log(this.showClubType)
    //   if (v != this.showClubType) {
    //     this.sendData.index = 1
    //     if (!this.isRefresh) {
    //       this.getData('getNewData', (type, clubType, erro) => {
    //         this.showClubType = clubType
    //       })
    //     }
    //     this.$refs.listTopic.setAllLoaded(false) //开启上拉加载
    //   }
    // }
  },
  computed: {
    // currentType() {
    //   console.log(this.sendData.type)
    //   return this.sendData.type
    // },
    // currentClubType() {
    //   return this.sendData.clubType
    // },
    isMoneyMode() {
      if (this.showClubType == 0) {//元宝模式
        return true
      } else {//钻石模式 为 1
        return false
      }
    }
  },
  methods: {
    getData(params, callback) {
      // submemberInfo: urlPrev + "subManager/memberInfo",         //其它商务下的代理信息
      let that = this
      this.$http.get(this.url, {
        params: that.sendData
      }).then(function (res) {
        if (res.code == 0) {
          that.loader = true;

          that.zhijieTotal = res.data.count1
          that.jianijieTotal = res.data.count2

          that.dataLength = res.data.list.length;
          if (that.dataLength > 0) {
            // that.sendData.lastIndex = res.data.list[that.dataLength - 1].id
            for (let i = 0; i < that.dataLength; i++) {
              that.list.push(res.data.list[i])
            }
            if (params == 'getNewData') {//下拉 刷新 或者 搜索 时  获取新数据 避免使用清空数组造成的闪屏
              for (let i = 0; i < that.dataLength; i++) { //新数据有多少条
                that.list[i] = res.data.list[i]
              }
              that.list.length = that.dataLength;//截取数组长度
            }
          } else {
            that.$refs.listTopic.setAllLoaded(true) //已加载完
            that.$toast({
              message: '没有更多数据',
              position: 'bottom',
              duration: 2000
            });
          }
          if (typeof callback == 'function') {
            callback(that.sendData.type, that.sendData.clubType)
          }
        } else {
          that.$toast(res.message)
        }
      })
    },
    loadTop() {
      let that = this
      that.sendData.index = 1
      that.$refs.listTopic.setAllLoaded(false) //开启上拉加载
      setTimeout(function () {
        that.$refs.listTopic.onTopLoaded();
      }, 1000)
      that.getData('getNewData')

    },

    loadBottom() {
      let that = this;
      if (!this.loader) {
        return
      }
      that.sendData.index += 1
      that.getData()
      setTimeout(function () {
        that.$refs.listTopic.onBottomLoaded();
      }, 1000)

    },
    changLeague(league) {
      let that = this;
      that.focusNum = league
      if (league == '') {
        that.sendData.isLeague = ''
      } else if (league == 1) {
        that.sendData.isLeague = 1
      } else if (league == 2) {
        that.sendData.isLeague = 0
      }
      that.getData('getNewData')
    },
    changType(params) {
      let that = this
      that.sendData.type = params

      var clickTime = new Date().getTime()
      // console.log(clickTime - that.lastClickTime)
      if (clickTime - that.lastClickTime > 1300) {
        that.lastClickTime = new Date().getTime()
      } else {
        that.$toast('操作频繁,请稍后再试')
        return
      }

      this.getData('getNewData', (type, clubType) => {
        this.showType = type
      })
    },
    changClubType(params) {
      let that = this
      that.sendData.clubType = params

      var clickTime = new Date().getTime()
      // console.log(clickTime - that.lastClickTime)
      if (clickTime - that.lastClickTime > 1300) {
        that.lastClickTime = new Date().getTime()
      } else {
        that.$toast('操作频繁,请稍后再试')
        return
      }

      this.getData('getNewData', (type, clubType) => {
        this.showClubType = clubType
      })
    },
    clear() {
      this.sendData.param = '';
      this.getData('getNewData')
    },
    sort(params) {
      this.sendData.order = params;
      this.sendData.index = 1;
      this.getData('getNewData')
      this.sortSwitch()
    },
    sortSwitch() {
      this.sortListShow = !this.sortListShow
    },
    districtSwitch() {
      this.districtShow = !this.districtShow
    },
    select() {
      this.getData('getNewData')
    },

    /******
     * 打开时间选择
     * ***/
    openPick(param) {
      var that = this
      that.$refs[param].open()
    },
    /******
     * 确认时间
     * ***/
    handleConfirm(param) {
      if (param == 'start') {
        let d = new Date(this.pickerValue)
        let time = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate()
        this.startValue = time
        this.sendData.begin = new Date(time).getTime()
      } else if (param == 'end') {
        let d = new Date(this.pickerValue2)
        let time = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate()
        this.endValue = time
        this.sendData.end = new Date(time).getTime()
      }
    },
    search() {
      this.getData('getNewData')
    },
    refresh() {
      var that = this
      that.isRefresh = true;
      var t = setTimeout(function () {
        that.isRefresh = false;
      }, 1200)
      that.$set(that.sendData, 'type', 1)
      that.$set(that.sendData, 'clubType', 0)
      that.sendData = {
        index: 1,
        type: 1,//默认直接接推荐
        clubType: 0,
        timeOrder: 1,
        roomOrder: 3,
        order: 3,
        level: '',
        param: '',
        district: '',
        begin: '',
        end: ''
      }
      if (that.$route.query.managerId) {
        this.url = '/subManager/memberList'
        this.sendData.managerId = that.$route.query.managerId
      }
      that.getData('getNewData')
    },
    ctrDetails(params) {
      this.detailShow = params;
    },
    details(id) {
      this.memberId = id;
      this.ctrDetails(true)
    }
  },


  mounted: function () {

  },
  created: function () {
    //区分其他商务 该页面不能进行缓存操作！！
    if (this.$route.query.managerId) {
      this.url = '/subManager/memberList'
      this.sendData.managerId = this.$route.query.managerId
      this.replaceTitleShow = true
    }
    this.startDate = new Date(Number(localStorage.getItem("startTime")));
    this.endDate = new Date(Number(localStorage.getItem("endTime")));
    this.pickerValue = this.startDate.getFullYear() + '/' + (this.startDate.getMonth() + 1) + '/' + this.startDate.getDate();
    this.pickerValue2 = this.endDate.getFullYear() + '/' + (this.endDate.getMonth() + 1) + '/' + this.endDate.getDate();
    this.getData()
  }

}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
.picker {
  height: 0.8rem;
  margin: 0 4px;
}

.searchBtn {
  width: 100%;
  height: 0.6rem;
  margin-right: 4px;
}
.closeBtn {
  position: relative;
  width: 1rem;
  height: 0.6rem;
}
.startTime,
.endTime {
  height: 0.6rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 0 2px;
}
.nav {
  height: 0.7rem;
}

.focusBtn {
  background: #3d435f;
  color: #fff;
}
.focus {
  border-bottom: 1px solid #087e82;
  color: #087e82;
}

.player {
  margin-bottom: 10px;
}

.avatar {
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
  border: 1px solid #0c8387;
  padding: 1px;
  margin-right: 5px;
}

ul {
  li {
    line-height: 1.5;
    padding: 10px;
    min-height: 1.2rem;
  }
}

.overView {
  position: absolute;
  width: 100%;
  height: calc(100vh - 4.7rem);
  background: rgba(0, 0, 0, 0.5);
  top: 3.7rem;
  left: 0;
  z-index: 1;
}
.iconXiajiantou,
.iconShangjiantou {
  font-size: 0.2rem;
}
.search {
  height: 0.8rem;
  padding: 0 10px;
}
.dirBtn {
  margin: 4px;
  height: 0.6rem;
  line-height: 0.6rem;
  min-width: 1.46rem;
  padding: 4px 4px 4px 0;
  color: #000;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.statusBtn {
  margin: 4px;
  height: 0.6rem;
  line-height: 0.6rem;
  min-width: 1.46rem;
  padding: 4px 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #cccccc;
}
.selectDistrict {
  border: none;
  width: 100%;
  padding: 0 0 0 15px;
  outline: none;
  background: #fff;
}
.searchInput {
  margin: 4px;
  height: 0.6rem;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}
ul.sortList {
  position: absolute;
}
ul.sortList,
ul.part {
  width: 100%;
  background: #fff;
  top: 1px;
  left: 0;
  z-index: 2;
  // display: flex;
  flex-grow: 2;
  flex-wrap: wrap;
  li {
    width: calc(100% / 2);
    padding: 0 10px;
    position: relative;
    min-height: 0.7rem;
    .trueIcon {
      position: absolute;
      right: 0;
      top: 50%;
      -webkit-transform: translate3d(-50%, -50%, 0);
      transform: translate3d(-50%, -50%, 0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/member/index.vue